<template>
  <div>
    <recherche-action></recherche-action>
    <h3>Evenements</h3>
    <div class="icon-list">
      <div v-for="evenement in evenements" :key="evenement.id" class="amsom-button"
           @click="setSelectedEvenementAndRedirectToActions(evenement.id)">
        <button class="btn btn-primary">
          <i :class="fontawesomeico(evenement.id)"></i>
        </button>
        <span class="amsom-button-libelle">{{ evenement.libelle }}</span>
      </div>
    </div>
  </div>
</template>

<script>

import RechercheAction from "./RechercheAction";
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "Evenements",
  components: {RechercheAction},
  computed: {
    ...mapGetters('evenements', ['iCanWrite']),
    evenements() {
      return this.iCanWrite;
    }
  },
  methods: {
    ...mapActions('evenements', ['setSelectedEvenement']),
    ...mapActions('actions', ['setSelectedAction']),
    setSelectedEvenementAndRedirectToActions(evenementID) {
      this.setSelectedEvenement(evenementID)
      this.$router.push({name: 'actions'})
    },
    fontawesomeico(ID) {
      if (ID === "TECH") return 'fas fa-tools'
      return 'fas fa-cog'
    }
  },
  // computed: {
  //   evenements() {
  //     // return JSON.parse(this.$store.getters['evenements/'].evenements)
  //     return this.$store.getters['evenements/'].getMyEvenement()
  //   }
  // },
  mounted() {
    this.setSelectedEvenement(null)
    this.setSelectedAction(null)

    if (this.evenements.length === 1){
      this.setSelectedEvenement(this.evenements[0].id)
      this.$router.push({
        name: 'actions'
      });
    }
  }
}
</script>

<style scoped>

</style>